<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Kasa Güncelle</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body">
      <form [formGroup]="form">
        <div class="mb-3">
            <label for="caseName">Kasa Adı</label>
          <div class="input-group">
            <input id="caseName" class="form-control" type="text" formControlName="caseName" [(ngModel)]="model.name">
          </div>
        </div>
        <div class="mb-3">
          <label>Kasa Tipi</label>
          <div class="input-group">
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="caseTypeCashEdit" name="caseTypeEdit" [value]="CaseType.Cash" [(ngModel)]="model.caseType" [ngModelOptions]="{standalone: true}" (ngModelChange)="caseTypeChanged()">
              <label class="form-check-label" for="caseTypeCashEdit">Nakit</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="caseTypeBankEdit" name="caseTypeEdit" [value]="CaseType.Bank" [(ngModel)]="model.caseType" [ngModelOptions]="{standalone: true}" (ngModelChange)="caseTypeChanged()">
              <label class="form-check-label" for="caseTypeBankEdit">Banka</label>
            </div>
            <div class="form-check form-check-inline">
              <input class="form-check-input" type="radio" id="caseTypePosEdit" name="caseTypeEdit" [value]="CaseType.Pos" [(ngModel)]="model.caseType" [ngModelOptions]="{standalone: true}" (ngModelChange)="caseTypeChanged()">
              <label class="form-check-label" for="caseTypePosEdit">POS (Kredi Kartı)</label>
            </div>
          </div>
        </div>

        <!-- POS ayarları (banka, taksit, komisyon) kasaya değil terminale ait olduğu için
             ayrı uçtan yönetilir. -->
        <div class="alert alert-info py-2" *ngIf="model.caseType === CaseType.Pos">
          <i class="fas fa-credit-card me-1"></i>
          Bağlı banka, taksit seçenekleri ve komisyon oranları <strong>Kasa &gt; POS Ayarları</strong>
          ekranından tanımlanır.
        </div>

        <ng-container *ngIf="model.caseType === CaseType.Bank">
          <div class="mb-3">
            <label>Banka Hesabı Kaynağı</label>
            <div class="input-group">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="bankAccountModeNewEdit" name="bankAccountModeEdit" value="new" [(ngModel)]="bankAccountMode" [ngModelOptions]="{standalone: true}" (ngModelChange)="bankAccountModeChanged()">
                <label class="form-check-label" for="bankAccountModeNewEdit">Yeni Banka Hesabı Ekle</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="bankAccountModeExistingEdit" name="bankAccountModeEdit" value="existing" [(ngModel)]="bankAccountMode" [ngModelOptions]="{standalone: true}" (ngModelChange)="bankAccountModeChanged()">
                <label class="form-check-label" for="bankAccountModeExistingEdit">Mevcut Hesaplardan Seç</label>
              </div>
            </div>
          </div>

          <div class="mb-3" *ngIf="bankAccountMode === 'existing'">
            <label for="existingBankAccountIdEdit">Banka Hesabı <span class="text-danger">*</span></label>
            <div class="input-group">
              <select id="existingBankAccountIdEdit" class="form-control form-select" [(ngModel)]="model.existingBankAccountId" [ngModelOptions]="{standalone: true}">
                <option [ngValue]="undefined">...Banka Hesabı Seçiniz...</option>
                <option *ngFor="let item of existingBankAccounts" [ngValue]="+item.value">{{ item.text }}</option>
              </select>
            </div>
          </div>

          <ng-container *ngIf="bankAccountMode === 'new'">
            <div class="mb-3">
              <label for="bankIdEdit">Banka <span class="text-danger">*</span></label>
              <div class="input-group">
                <select id="bankIdEdit" class="form-control form-select" [(ngModel)]="model.bankId" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="undefined">...Banka Seçiniz...</option>
                  <option *ngFor="let item of banks" [ngValue]="+item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="bankBranchCodeEdit">Şube Kodu</label>
                  <div class="input-group">
                    <input id="bankBranchCodeEdit" type="text" class="form-control" [(ngModel)]="model.bankBranchCode" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="bankBranchNameEdit">Şube Adı</label>
                  <div class="input-group">
                    <input id="bankBranchNameEdit" type="text" class="form-control" [(ngModel)]="model.bankBranchName" [ngModelOptions]="{standalone: true}">
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <label for="bankAccountNumberEdit">Hesap No</label>
              <div class="input-group">
                <input id="bankAccountNumberEdit" type="text" class="form-control" [(ngModel)]="model.bankAccountNumber" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="mb-3">
              <label for="bankAccountIbanEdit">Iban</label>
              <div class="input-group">
                <input id="bankAccountIbanEdit" type="text" class="form-control" placeholder="TR..." [(ngModel)]="model.bankAccountIban" [ngModelOptions]="{standalone: true}">
              </div>
            </div>
            <div class="mb-3">
              <label for="bankAccountCurrencyCodeEdit">Para Birimi <span class="text-danger">*</span></label>
              <div class="input-group">
                <select id="bankAccountCurrencyCodeEdit" class="form-control form-select" [(ngModel)]="model.bankAccountCurrencyCode" [ngModelOptions]="{standalone: true}">
                  <option [ngValue]="undefined">...Para Birimi Seçiniz...</option>
                  <option *ngFor="let item of currencyCodes" [ngValue]="item">{{ item }}</option>
                </select>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="submit()">Kaydet</button>
      <button type="button" class="btn btn-secondary" (click)="modal.close('Save click')">Geri Dön</button>
    </div>
  </ng-template>

  <button class="btn btn-sm btn-warning mb-2" *hasRole="[Role.Admin, Role.SuperAdmin]" (click)="open(content)"> <i class="fa fa-pen"></i> Güncelle</button>